import React from "react";
import { useNavigate } from "react-router-dom";
import { RectangleContainer } from "../atoms/rectangle-container";
import { ActionButtons } from "../atoms/action-buttons";
import { useSubmission } from "../../providers/submission-provider";

interface SubmissionSuccessfulProps {
  completionId: string;
  payout: string;
}

export const SubmissionSuccessful: React.FC<SubmissionSuccessfulProps> = ({
  completionId,
  payout,
}) => {
  const navigate = useNavigate();
  const { submission } = useSubmission();

  return (
    <div className="w-full max-w-lg mx-auto p-6 text-center space-y-4">
      {/* Icon */}
      <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-[rgba(34,197,94,0.3)] text-[rgba(34,197,94,1)]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
          className="w-8 h-8"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12l2 2 4-4m5 2a9 9 0 11-6.219-8.56"
          />
        </svg>
      </div>

      {/* Submission Message */}
      <h1 className="text-2xl font-bold text-black">Submission Successful!</h1>
      <p className="text-dark-gray text-sm">
        Your recording has been uploaded and will be reviewed by our team.
      </p>

      {/* Rectangle Section */}
      <RectangleContainer className="bg-support-gray-1 border-none rounded-lg text-sm text-black">
        Completion ID: <span className="font-semibold">{submission?.id}</span>
      </RectangleContainer>

      {/* Payment Status Section */}
      {/*<div className="text-center text-xs space-y-2">*/}
      {/*  <span className="block text-dark-gray font-semibold">*/}
      {/*    Payment Status*/}
      {/*  </span>*/}
      {/*  <span className="block text-progress-ok bold">*/}
      {/*    ${payout} -{" "}*/}
      {/*    <span className="text-progress-ok font-medium bold">Pending</span>*/}
      {/*  </span>*/}
      {/*  <span className="block text-dark-gray text-xs font-semibold">*/}
      {/*    Will be processed in 24-48 hours*/}
      {/*  </span>*/}
      {/*</div>*/}

      {/* Action Buttons */}
      <ActionButtons
        primaryText="Find More Tasks"
        secondaryText="View History"
        onPrimaryClick={() => navigate("/")}
        onSecondaryClick={() => navigate("/history")}
      />
    </div>
  );
};
